<template>
  <ApolloQuery :query="$options.query.customer" :variables="{ id }">
    <template v-slot="{ result: { loading, error, data } }">
      <!-- Loading -->
      <div v-if="loading" class="loading apollo">
        Loading...
      </div>

      <!-- Error -->
      <div v-else-if="error" class="error apollo">
        An error occurred
      </div>

      <!-- Result -->
      <div v-else-if="data" class="result apollo">
        {{ data.getCustomer.name }}
      </div>

      <!-- No result -->
      <div v-else class="no-result apollo">
        No result :(
      </div>
    </template>
  </ApolloQuery>
</template>
<script>
import gql from 'graphql-tag';

export default {
  props: {
    id: String
  },
  query: {
    customer: gql`
      query customer($id: ID!) {
        getCustomer(id: $id) {
          name
          _id
        }
      }
    `
  }
};
</script>
